import React, { ReactElement } from 'react'
import { CenterContainer, Container } from '../Global'
import I18NText from '../I18NText'

export const UnsupportedBrowser = () => {
  return (
    <>
      <CenterContainer>
        <Container width="580px" textAlign="center">
          <Container preset="h1" textTransform="unset" fontSize="24px">
            <I18NText id="unsupportedBrowser.title" />
          </Container>
          <Container margin="24px 8px">
            <I18NText id="unsupportedBrowser.description" />
          </Container>
        </Container>
      </CenterContainer>
    </>
  )
}
